import { useFormContext } from 'react-hook-form';

/**
 * Reads the current RHF error for `name` from context and renders a small
 * danger-colored hint below the input. Returns null when there's no error.
 *
 * Pairs with `<Input invalid={...}>` for the red border. Kept separate so
 * the border and the message can be placed independently in complex layouts
 * (e.g., a row of three fields where each gets its own error line below).
 */
export function FieldError({ name }: { name: string }) {
  const ctx = useFormContext();
  if (!ctx) return null;
  const err = ctx.formState.errors[name];
  if (!err) return null;
  const message = typeof err.message === 'string' ? err.message : 'Invalid value';
  return <p className="text-xs text-danger mt-1">{message}</p>;
}

/**
 * Convenience: returns `true` if the named field has a current error in the
 * form context. Use to drive the `invalid` prop on <Input>/<Textarea>/<Select>.
 */
export function useFieldInvalid(name: string): boolean {
  const ctx = useFormContext();
  return !!ctx?.formState.errors[name];
}
